import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemsAlternativesComponent } from './systems-alternatives.component';
import { RouterModule } from '@angular/router';
import { EmptyComponentModule } from '../empty-component/empty-component.module';
import { PaymentMethodsSlideModule } from '@app/transactions/pages/transaction-vcc/payment-methods-slide/payment-methods-slide.module';

@NgModule({
    declarations: [SystemsAlternativesComponent],
    exports: [SystemsAlternativesComponent],
    imports: [CommonModule, PaymentMethodsSlideModule, RouterModule, EmptyComponentModule]
})
export class SystemsAlternativesModule {}
